"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Return a deduped, sorted list of names from the start and end queues of a
 * beacon payload.
 */
function getBeaconEventNames(eventsStart, eventsEnd) {
    // `eventsStart` is already an array of eventNames, but `eventsEnd` is an
    // array of EndEvents, so we need to extract the event names first.
    const endEventNames = eventsEnd.map((event) => Object.keys(event)[0]);
    const combinedEventNames = [...eventsStart, ...endEventNames];
    // Remove duplicate event names and sort before returning
    return [...new Set(combinedEventNames)].sort();
}
exports.default = getBeaconEventNames;
